<div class="row section-row" [formGroupName]="formControlName">
  <div class="col section-col">
    <h5 class="section-heading">Other</h5>
  </div>
</div>
<app-capture-details
  [parentFormGroup]="formGroup"
  [showSeriousIncident]="false"
>
</app-capture-details>
